var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"error-box"},[_c('h2',[_vm._v("403")]),_c('p',[_vm._v("Forbidden - You don't have permission to access this page.")]),_c('router-link',{staticClass:"back-btn",attrs:{"to":{ path: '/', replace: true }}},[_vm._v("Go Back to Home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }